<template>
  <page>
    <div :id="pageId" :class="pageId" class="m-grid__item m-grid__item--fluid m-wrapper ls-custom-page" v-if="page">
      <!-- BEGIN: Subheader -->
      <div :class="pageId" class="m-subheader" >
        <div class="d-flex align-items-center break-word">
          <div class="mr-4" v-if="this.backUrl">
            <button class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls" @click="redirectToPreviousRoute">{{$t('Back')}}</button>
          </div>
          <h1 :class="pageId" class="m-subheader__title full-max-width" v-encode="page.title"></h1>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content break-word m-content-ls" :class="pageId">
        <div class="m-portlet m-portlet--full-height" :class="pageId">
          <div class="m-portlet__body overflow-x-auto" :class="pageId" v-html="page.content"></div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {mapActions} from 'vuex'
import Encode from "@/directives/encode";
import Page from "./Page";
import iframeResize from 'iframe-resizer/js/iframeResizer';
import http from "@/axios";
import {fail, finish, start} from "@/utils/Progress";
import {entityUuidFromLocation} from "@/utils/EntityUuid";
import store from "@/store";

export default {
  name: "CustomPage",
  components: {Page},
  directives: {Encode},
  data() {
    return {
      iframes: [],
      page: null,
      pageId: '',
      backUrl: null
    };
  },
  beforeRouteEnter(to, from, next) {
    start();

    const storageKey = 'ls-member-module-' + entityUuidFromLocation();
    const state = JSON.parse(localStorage.getItem(storageKey));

    if (!state) {
      fail();
      next(vm => {
        vm.$router.push({name: 'LoginPage'})
      });
      return;
    }
    http.get(`page/${to.params.pageUuid}`, {
      headers: {
        Authorization: `Bearer ${state.auth.token}`
      }
    })
        .then((r) => {
          if(r.data.cookie){
            document.cookie =
                "Token=" + `${state.auth.token}` + ";" + 60*60 + ";path=/mixer";
          }
          next(vm => {
            vm.setPage(r.data.page)

            if (to.params.hasOwnProperty('back')) {
              vm.enableBack(from.fullPath);
            }
          })
          finish();
        })
        .catch((e) => {
          fail();

          if (e.response.status === 403) {
            const matchingRoute = store.getters.getMatchingRoute(to);

            next(vm => {
              vm.setPage({
                title: matchingRoute ? matchingRoute.title : '',
                content: this.$t('Access denied')
              })
            });

            return;
          }

          next(vm => {
            vm.pushToFirstAvailablePage();
          });
        })
  },
  beforeRouteUpdate(to, from, next) {
    start();

    http.get(`page/${to.params.pageUuid}`)
        .then((r) => {
          this.setPage(r.data.page);
          next();
        })
        .then(() => finish())
        .catch((e) => {
          fail();
          if (e.response.status === 403) {
            const matchingRoute = store.getters.getMatchingRoute(to);

            this.setPage({
              title: matchingRoute ? matchingRoute.title : '',
              content: this.$t('Access denied')
            })
          } else {
            this.pushToFirstAvailablePage();
          }

          next();
        })
  },
  mounted() {
    this.initIframeResize();
  },
  beforeDestroy() {
    // Sprzątanie postMessage listenerów iframe-resizer'a — bez tego po
    // wyjściu ze strony handler'y żyją w pamięci aż do reload'u.
    if (this.iframes && this.iframes.length) {
      this.iframes.forEach((iframe) => {
        iframe.iFrameResizer && iframe.iFrameResizer.removeListeners();
      });
    }
  },
  methods: {
    ...mapActions([
      'pushToFirstAvailablePage'
    ]),
    initIframeResize(destroy = false) {
      this.pageId = "page-"+this.$route.params.pageUuid;
      if (destroy && this.iframes.length) {
        this.iframes.map((iframe) => {
          iframe.iFrameResizer.removeListeners();
        })
      }
      setTimeout(() => {
        this.iframes = iframeResize({
          checkOrigin: false,
          heightCalculationMethod: 'taggedElement',
          log: false,
        }, '.resize-iframe');
      }, 1);
    },
    setPage(page) {
      this.$set(this, 'page', page);
    },
    enableBack(url) {
      this.$set(this, 'backUrl', url);
    },
    redirectToPreviousRoute() {
      this.$router.push(this.backUrl);
    }
  },
  computed: {},
  watch: {
    page(page) {
      if (page === undefined) {
        this.pushToFirstAvailablePage();
        return;
      }

      this.initIframeResize(true);
    }
  }
}
</script>

<style>
.overflow-x-auto {
  overflow-x: auto;
}

.m-content-ls a {
  color: var(--accent-color) !important;
}

.break-word {
  -ms-word-wrap: break-word;
  word-wrap: break-word;
}

.full-max-width {
  max-width: 100% !important;
}

iframe {
  min-width: 100%;
}
</style>
